import { Injectable, Inject } from '@angular/core';

import { AudioLibraryService } from '@new-core/app/scripts/services/audio-library.service';

/**
 * Service that provides audio messages.
 */
@Injectable()
export class AudioManager {
  constructor(
    @Inject(AudioLibraryService)
    private audioLibraryService: AudioLibraryService,
  ) {}

  /**
   * Play a beep to indicate an error
   */
  sendError() {
    this.audioLibraryService.collect.play();
  }

  /**
   * Play a friendly click to indicate a success
   */
  sendSuccess() {
    this.audioLibraryService.success.play();
  }
}
